import React, { useState, useEffect } from "react";
import "../CSS/Gallery.css";
import axios from "axios";

const Gallery = () => {
  const [galleryData, setGalleryData] = useState([]);

  useEffect(() => {
    fetchGalleryData();
  }, []);

  const fetchGalleryData = async () => {
    try {
      const response = await axios.get("https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/getGalleryContent1");
      const data = response.data ? Object.values(response.data) : [];
      setGalleryData(data);
    } catch (error) {
      console.error("Error fetching gallery data:", error);
    }
  };

  const carouselDiameter = Math.max(500, 85 * galleryData.length);

  return (
    <div className="Gallerysection">
      {galleryData.map((item) => (
        <div key={item.service_id} className="p-4">
          {/* Title and Description */}
          <h1 className="mb-4 text-center galleryh1 blackthemegradient">{item.title}</h1>
          <p className="Galleryp text-white">{item.description}</p>
          
          {/* Carousel Section */}  
          <div className="carousel" style={{ '--carousel-diameter': `${carouselDiameter}px` }}>
            <div className="carousel-control-button left">
              <input type="radio" name="carousel-control-input" />
            </div>
            <div className="carousel-control-button right">
              <input type="radio" name="carousel-control-input" defaultChecked />
            </div>

            <div className="carousel-rotation-direction">
              <ul className="carousel-item-wrapper" style={{ "--_num-elements": item.subtitles2.length }}>
                {item.subtitles2.map((subtitle) => (
                  <li
                    key={subtitle.subtitle_id}
                    className="carousel-item"
                    style={{
                      "--_index": subtitle.subtitle_id,
                      "--_image-url": `url(${subtitle.subimage})`,
                    }}
                  >
                    <a href={subtitle.subimage} target="_blank" rel="noopener noreferrer">
                      {subtitle.subtitle}
                    </a>
                  </li>
                ))}
                <li className="carousel-ground"></li>
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Gallery;
